import {
  EXPERIMENT_VARIATION,
  SAMEDAY_DELIVERY,
} from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperiments,
} from 'shared/experiments/utils/experiments'
import store from 'shared/store'
import { optimizelyVisitor } from 'views/assets/scripts/OptimizelyVisitor'

const activateExperimentManually = () => {
  const {
    publicConfig: { tenant, language },
  } = store.getPublicRuntimeConfig()
  const visitor =
    optimizelyVisitor.getVisitorData() || optimizelyVisitor.createVisitor()

  return fetch(`/webclient/experiments/${tenant}/${language}/activate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      featureKeys: [SAMEDAY_DELIVERY],
      userAttributes: {
        visitor: visitor.status,
      },
      withCredentials: true,
    }),
  })
}

const activateSamedayDeliveryExperiment = async () => {
  const {
    pageProperties: { experiments },
  } = store.getPublicRuntimeConfig()

  const experiment = getExperiments([SAMEDAY_DELIVERY], experiments)[0] || {}
  if (experiment.isEnabled) {
    if (experiment.variant === EXPERIMENT_VARIATION.DEFAULT) {
      await activateExperiment(SAMEDAY_DELIVERY)
    } else {
      // FIXME `activateExperiment` does fail for some weird reason for V1-V2
      // I didn't find a source of the issue during a couple of hours of debugging,
      // so call the endpoint manually while there is no other way and not to block the experiment
      await activateExperimentManually()
    }
  }
}

export default activateSamedayDeliveryExperiment
